import MainLayout from '../layouts/main';
import DecksContainer from './container';
import DecksTab from './tab';

function DecksPage() {
  return (
    <MainLayout>
      <DecksTab />
      <DecksContainer />
    </MainLayout>
  );
}

export default DecksPage;
